import React from "react";
import PropTypes from "prop-types";
import PublicationRecord from "./PublicationRecord";
import { ContentBlock } from "../../shared";

const PublicationResults = ({ records, total }) => {
  return (
    records.length > 0 && (
      <ContentBlock className="m-record-results">
        <header className="a-hidden">
          <h2>{total} Results</h2>
        </header>
        <div className="m-grid m-grid--2">
          <div className="m-grid__items">
            {records.map((publication) => (
              <PublicationRecord
                key={publication.id}
                publication={publication}
              />
            ))}
          </div>
        </div>
      </ContentBlock>
    )
  );
};

PublicationResults.propTypes = {
  records: PropTypes.arrayOf(PropTypes.object),
  total: PropTypes.number,
};

export default PublicationResults;
